module.exports = __webpack_public_path__ + "img/banner_evento_funcionarios.f5953204.png";